module.exports = __webpack_public_path__ + "media/images/icons/flag-fill-50d49e5dd2a2cbe7b88f7ca75cfeab65.png";